var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmuteMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2965 19.8276C18.2226 20.8036 16.9001 21.4639 15.4747 21.7356C14.0493 22.0074 12.5765 21.8801 11.2189 21.3678C9.86133 20.8554 8.67166 19.978 7.78122 18.8322C6.89078 17.6865 6.33418 16.3171 6.17285 14.875",
    stroke: "#367B4E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9425 17.2375C16.138 17.9706 15.0884 18.3763 14 18.3748H14C12.8397 18.3748 11.7269 17.9138 10.9064 17.0934C10.0859 16.2729 9.625 15.1601 9.625 13.9998V9.1875",
    stroke: "#367B4E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.875V25.375",
    stroke: "#367B4E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.375L22.75 23.625",
    stroke: "#367B4E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2769 4.70141C10.6687 4.06635 11.2165 3.54214 11.8683 3.17868C12.52 2.81522 13.2539 2.62461 14.0001 2.625H14.0001C14.5746 2.625 15.1435 2.73816 15.6743 2.95803C16.2051 3.17789 16.6874 3.50015 17.0937 3.90641C17.4999 4.31266 17.8222 4.79496 18.0421 5.32575C18.2619 5.85655 18.3751 6.42546 18.3751 6.99999V13.6094",
    stroke: "#367B4E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8271 14.875C21.7519 15.5577 21.587 16.2276 21.3369 16.8673",
    stroke: "#367B4E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteMic);
export default __webpack_public_path__ + "static/media/unmute-mic.aa862e55a3ea4d3a5a08fb7aed0ccf45.svg";
export { ForwardRef as ReactComponent };